import React from 'react';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { ListItem } from './AppointAdminTerms';

export const AccountantInviteTerms = () => {
  const textClassName = 'text-text-main-primary text-left inline';

  return (
    <div className='flex flex-col items-start gap-[20px]'>
      <Heading.H9 fontWeight={FontWeight.MEDIUM} className={textClassName}>
        Add an Authorized Viewer to Your Account
        <Heading.H9 className={textClassName}> (“View Only Authorization”)</Heading.H9>
      </Heading.H9>
      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        This View Only Authorization allows you to give another person, such as your accountant, lawyer or financial
        advisor (“Authorized Viewer”) access to your account information without transaction authority. Given the
        sensitive nature of the information you will be sharing with the Authorized Viewer, you should carefully
        consider whether to grant View Only Access.
      </Text.H9>
      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        Please read the following important information before providing us with the Authorized Viewer information:
      </Text.H9>

      <div className='flex flex-col  px-[24px]'>
        <ListItem text='The Authorized Viewer will be able to review, print, download, and save your account information, including but not limited to your tax information, balances, transactions, statements, invoices, and other non-public information such as your date of birth, social security number and mailing address;' />
        <ListItem text='The Authorized Viewer will have access to your account until you terminate his or her access or until you close the account;' />
        <ListItem text='The Authorized Viewer will not have the ability to conduct transactions, move money into or out of your account, or change your account settings.' />
      </div>
      <div className='flex flex-col items-start gap-[20px]  px-[24px]  '>
        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          By signing this View Only Authorization, I hereby authorize Lili App Inc. (Lili) and Sunrise Banks, N.A.
          (Sunrise) to provide the person named below (“Authorized Viewer”) access to this Lili account. I consent to
          and authorize Lili to give my Authorized Viewer the ability to review, print, download, save, and distribute
          account data, including statements, transaction history, and account profile information. I understand that by
          granting View Only Access to the Authorized Viewer, he or she will have access to personal information
          contained in my account, including my Social Security number, account number, mailing address, telephone
          number, and email address. I understand that the information available to the Authorized Viewer will include
          non-public personally identifiable information about me and any other authorized users. By checking the box
          below, I direct and provide consent to Lili to share my non-public personally identifiable information with
          the Authorized Viewer. I agree that I will indemnify and hold harmless Lili from any and all matters arising
          from this authorization and that Lili is not responsible in any way for any damages that may arise from my
          granting View Only Access to the individual below.
        </Text.H9>

        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          If this account is a legal entity account, such as an LLC, S Corp, or Partnership I hereby certify that I have
          authority on behalf of the legal entity to grant View Only access to this account.
        </Text.H9>
      </div>
    </div>
  );
};
